import AgencyHeaderWidget from "./widgets/AgencyHeaderWidget";
import ClockWidget from "./widgets/ClockWidget";
import CurrentWeatherWidget from "./widgets/CurrentWeatherWidget";
import MemosWidget from "./widgets/MemosWidget";
import DutyCrewWidget from "./widgets/DutyCrewWidget";
import UnitStatusWidget from "./widgets/UnitStatusWidget";
import AlarmMapWidget from "./widgets/AlarmMapWidget";
import DepartmentCalendarWidget from "./widgets/DepartmentCalendarWidget";
import LeadershipWidget from "./widgets/LeadershipWidget";
import WeatherRadarWidget from "./widgets/WeatherRadarWidget";
import MediaRotationWidget from "./widgets/MediaRotationWidget";
import WorkOrdersWidget from "./widgets/WorkOrdersWidget";
import FleetStatusWidget from "./widgets/FleetStatusWidget";
import TrainingCertsWidget from "./widgets/TrainingCertsWidget";
import InventoryWidget from "./widgets/InventoryWidget";
import RunStatsWidget from "./widgets/RunStatsWidget";
import StormMapWidget from "./widgets/StormMapWidget";
import TickerWidget from "./widgets/TickerWidget";
import { LegacyBoardScreen } from "./LegacyBoard";
import { StormCellsWidget, StormReportsWidget, NwsAlertsWidget } from "./widgets/StormPanels";
import {
  TextBlockWidget,
  ImageWidget,
  SpacerWidget,
  AnnouncementsWidget,
  PlaceholderWidget,
} from "./widgets/ContentWidgets";

// type -> component. Heavy/data-rich widgets (alarmMap, weatherRadar,
// mediaRotation, leadership, departmentCalendar, workOrders, fleetStatus,
// trainingCerts, inventory, runStats) are registered in later phases; until then
// they render the placeholder so a board referencing them never crashes.
const REGISTRY = {
  agencyHeader: AgencyHeaderWidget,
  clock: ClockWidget,
  currentWeather: CurrentWeatherWidget,
  memos: MemosWidget,
  dutyCrew: DutyCrewWidget,
  unitStatus: UnitStatusWidget,
  alarmMap: AlarmMapWidget,
  departmentCalendar: DepartmentCalendarWidget,
  leadership: LeadershipWidget,
  weatherRadar: WeatherRadarWidget,
  mediaRotation: MediaRotationWidget,
  workOrders: WorkOrdersWidget,
  fleetStatus: FleetStatusWidget,
  trainingCerts: TrainingCertsWidget,
  inventory: InventoryWidget,
  runStats: RunStatsWidget,
  stormMap: StormMapWidget,
  stormCells: StormCellsWidget,
  stormReports: StormReportsWidget,
  nwsAlerts: NwsAlertsWidget,
  announcements: AnnouncementsWidget,
  ticker: TickerWidget,
  textBlock: TextBlockWidget,
  image: ImageWidget,
  spacer: SpacerWidget,
  // Normally drawn full-screen by BoardView (see isLegacyScreen); registered
  // so it is never an "unknown widget".
  legacyBoard: LegacyBoardScreen,
};

export function registerWidget(type, component) {
  REGISTRY[type] = component;
}

export function getWidget(type) {
  const found = REGISTRY[type];
  if (found) return found;
  // Bind the unknown type into the placeholder so it shows a useful label.
  const Bound = (props) => PlaceholderWidget({ ...props, widgetType: type });
  return Bound;
}
